export const RagStatus = {
  Green: 1,
  Amber: 2,
  Red: 3,
  Yellow: 4,
};

export const ragStatusWithDesc = [
  { id: 3, Name: 'Red', description: 'High (red)', sortingOrder: 4 },
  { id: 2, Name: 'Amber', description: 'Medium High (amber)', sortingOrder: 3 },
  { id: 4, Name: 'Yellow', description: 'Medium (yellow)', sortingOrder: 2 },
  { id: 1, Name: 'Green', description: 'Low (green)', sortingOrder: 1 },
];

export const compareRag = (a, b) => {
  if (RagStatus[a] !== RagStatus.Yellow && RagStatus[b] !== RagStatus.Yellow)
    return RagStatus[a] > RagStatus[b] ? 1 : -1;

  if (RagStatus[a] === RagStatus.Yellow) return RagStatus[b] === RagStatus.Green ? 1 : -1;

  return RagStatus[a] === RagStatus.Green ? -1 : 1;
};
